// eslint-disable-next-line no-restricted-imports
import GatsbyImage from 'gatsby-image';
import React from 'react';

/**
 * Image - a site specific wrapper for Gatsby Image rearranging a few defaults
 */
export default function Image({
  fluid = undefined,
  fixed = undefined,
  backgroundColor = undefined,
  title = undefined,
  alt = '',
  fadeIn = false,
  durationFadeIn = 300,
  eager = false,
  draggable = undefined,
  crossOrigin = undefined,
  Tag = undefined,
  className = null,
  style = null,
  imgStyle = style,
  placeholderStyle = style,
  placeholderClassname = '',
}) {
  return (
    <GatsbyImage
      fluid={fluid}
      fixed={fixed}
      backgroundColor={backgroundColor}
      title={title}
      alt={alt}
      fadeIn={fadeIn}
      durationFadeIn={durationFadeIn}
      loading={eager ? 'eager' : 'lazy'}
      draggable={draggable}
      crossOrigin={crossOrigin}
      Tag={Tag}
      className={className}
      style={style}
      imgStyle={imgStyle}
      placeholderStyle={placeholderStyle}
      placeholderClassName={placeholderClassname}
    />
  );
}

// @ts-ignore
GatsbyImage.displayName = 'GatsbyImage';
Image.displayName = 'PwpImage';

export let imageStyles = {
  contain: { objectFit: 'contain', objectPosition: 'center center' },
  cover: { objectFit: 'cover', objectPosition: 'center center' },
};
